import { DangerousHtmlContent } from '@eti/components';
import { Notice, vars } from '@etg/wings';
import { cx } from '@eti/styles';
import { useProductCardContext } from '../../context/ProductCardContext';
import { DYNAMIC_ICON } from '../../utils/dynamic-icons/icons';
import { useDynamicIcon } from '../../utils/dynamic-icons/useDynamicIcon';
import { additionalInformationStyles, descriptionStyles, standardGrid, wrapperStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Body = _ref => {
  let {
    customGrid,
    children,
    className
  } = _ref;
  const {
    additionalInformation,
    description,
    promotionalText,
    productName
  } = useProductCardContext();
  const [icon] = useDynamicIcon(vars.colors.links.default, DYNAMIC_ICON.linkIcon);
  if (!description && !additionalInformation && !promotionalText && !children) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: cx(wrapperStyles, className, customGrid || standardGrid),
    "data-testid": `body-${productName}`,
    children: [description && /*#__PURE__*/_jsx(DangerousHtmlContent, {
      className: cx(descriptionStyles(icon), 'description'),
      content: description,
      "data-testid": `body-description-${productName}`
    }), additionalInformation && /*#__PURE__*/_jsx(DangerousHtmlContent, {
      className: cx(additionalInformationStyles(icon), 'additionalInformation'),
      content: additionalInformation,
      "data-testid": `body-additionalInformation-${productName}`
    }), promotionalText && /*#__PURE__*/_jsx(Notice, {
      className: "promotionalText",
      "data-testid": `body-promotionalText-${productName}`,
      variant: "promotional",
      children: promotionalText
    }), children && /*#__PURE__*/_jsx("div", {
      className: "children",
      "data-testid": `body-children-${productName}`,
      children: children
    })]
  });
};
export default Body;
//# sourceMappingURL=Body.js.map